/**
 * TEMA ESCURO — "a tela".
 *
 * O QUE ELE ERA. `background: "#8a8879"` (um cinza-oliva) com `text: "#000000"`.
 * Isso não é um tema escuro: é o tema claro com os cartões apagados. Foi essa
 * mistura que produziu, medido no navegador, dois botões com **1,02:1** de
 * contraste — texto praticamente invisível.
 *
 * O QUE ELE É AGORA. O disco do ícone, que é a alma da marca: fundo de página
 * `--tela-fundo`, superfícies em `--tela`, elevação em `--tela-alta`.
 *
 * E O AMARELO PASSA A BRILHAR. No papel o ladrilho cheio dá 1,21:1 contra o
 * branco — ele SOME, e por isso lá ele é só moldura. Sobre a tela escura o mesmo
 * amarelo dá 12,52:1: é aqui que ele pode ser a cor de destaque. Por isso
 * `selection` é o ladrilho no escuro e a tinta azul no claro — mesma marca,
 * papéis trocados pelo fundo.
 *
 * As semânticas trocam de valor junto (ver SEMANTICAS.escuro): verde, âmbar e
 * vermelho claros, todos acima de 6:1 sobre a tela.
 */
import { CENTRAL, ESTRUTURA, SEMANTICAS } from "../global/tokens";

export const darkTheme = {
  title: "dark",
  colors: {
    /** Elevação: campo de formulário, linha destacada. */
    primary: ESTRUTURA.telaAlta,
    /** Superfície de cartão e de tabela. */
    background: ESTRUTURA.tela,
    text: ESTRUTURA.telaTexto,
    /** Destaque. 12,52:1 sobre a tela — é onde o amarelo do ícone brilha. */
    selection: CENTRAL.ladrilho,
    /*
     * MAIS ÊNFASE CONTRA O FUNDO ATUAL — e no escuro isso é mais CLARO.
     *
     * O nome `selectionDark` vem de quando só existia um tema; ele é usado como
     * fundo de hover em ~10 telas. Escurecer o amarelo sobre a tela preta
     * (#AC9001) reduz o contraste e embarra a cor: no fundo escuro, hover que
     * "escurece" desaparece. O idioma certo é o da casa (o sufixo `-claro` do
     * sistema de design): a variante é sempre a que ganha ênfase contra o fundo
     * ATUAL. No papel isso é mais escuro; aqui é mais claro.
     */
    selectionDark: "#FFF4B0",
    /** Cabeçalho e painel: uma elevação acima da superfície. */
    modalColor: ESTRUTURA.telaAlta,
    /**
     * Sobre o ladrilho cheio o único texto que passa é o carvão — é a regra 2
     * do sistema de design, e a conta confirma: branco sobre #FEE97B dá 1,22:1
     * e carvão dá 14,6:1. O par desta linha vive em `light.ts`, onde
     * `selection` é azul e quem aguenta por cima é o branco.
     */
    textOnPrimary: ESTRUTURA.carvao,
    /** Contorno de controle sobre a tela. */
    border: ESTRUTURA.telaLinhaForte,
    borderColor: ESTRUTURA.telaLinhaForte,
    label: ESTRUTURA.telaTexto2,
    danger: SEMANTICAS.escuro.erro,
    bom: SEMANTICAS.escuro.bom,
    aviso: SEMANTICAS.escuro.aviso,
    /** No escuro o "lavado" é a elevação, não um creme. */
    lavado: ESTRUTURA.telaAlta,
    ladrilhoBorda: CENTRAL.ladrilhoBorda,
  },
};
